import React, { useEffect, useMemo, useState } from "react";

import { useTranslation } from "react-i18next";

import { ContainerStatus } from "../../../../../models/marine.traffic";
import { MarineEventsStatus } from "../../../../../util/enums";
import { NotificationToast } from "../../../../Generic/Toast/NotificationToast";
import EventHeader from "../EventHeader";
import EventItem from "../EventItems";
import { ItemsDiv, MainDiv } from "./styles";

interface Props {
  shipmentHasTracking?: boolean;
  containerStatus?: ContainerStatus;
  containerName?: String;
  containerSize?: String;
  grossWeight?: string;
  isEventOpened?: boolean;
  onToggleEventOpened?: Function;
  isAirTracking?: boolean;
}

const EventContainer = ({
  containerStatus,
  containerName,
  containerSize,
  grossWeight,
  isEventOpened = false,
  shipmentHasTracking = true,
  onToggleEventOpened,
  isAirTracking = false,
}: Props) => {
  const [toggle, setToggle] = useState<boolean>(isEventOpened);
  const { t: translate } = useTranslation();
  const events = containerStatus?.eventsContainer;

  useEffect(() => {
    setToggle(isEventOpened);
  }, [isEventOpened]);

  const renderItems = () => {
    const eventLength = events?.length;

    if (!events || !toggle || !eventLength) return null;

    const items = events?.map((value, index) => {
      return (
        <EventItem
          key={index}
          event={value}
          last={index === eventLength - 1}
          isAirTracking={isAirTracking}
        />
      );
    });

    return <ItemsDiv> {items}</ItemsDiv>;
  };

  const onToggleEvent = () => {
    if (!events || !events?.length) {
      NotificationToast.warning(translate("notEventsToShowAtTheMoment"));

      return;
    }

    setToggle(!toggle);
    if (onToggleEventOpened) onToggleEventOpened();
  };

  const updatedStatus = [MarineEventsStatus.COMPLETED, MarineEventsStatus.IN_PROGRESS];

  const updatedEvents = useMemo(() => {
    return events?.filter((value) => updatedStatus.includes(value.status as MarineEventsStatus));
  }, [containerStatus]);

  const lastUpdatedEvent = updatedEvents?.slice(-1)?.[0] || events?.[0];

  return (
    <MainDiv>
      <EventHeader
        shipmentHasTracking={shipmentHasTracking}
        containerName={containerName}
        event={lastUpdatedEvent || undefined}
        toggle={toggle}
        setToggle={shipmentHasTracking ? () => onToggleEvent() : undefined}
        containerSize={containerSize}
        grossWeight={grossWeight}
        isAirTracking={isAirTracking}
      />
      {renderItems()}
    </MainDiv>
  );
};

export default EventContainer;
